import { Card, Flex, Grid, Paper, Text } from '@mantine/core';
import React from 'react';
import SolidBadge from '../../components/elements/SolidBadge';
import Button from '../../components/elements/Button';
import IconArrowRight from '../../components/icons/IconArrowRight';
import IconSubMerchant from '../../components/icons/IconSubMerchant';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import AlertInfo from '../../components/elements/AlertInfo';
import { STATUS_SUB_MERCHANT_VERIF } from '../../utils/constants';

export const renderStatusRegistration = (statusReg, statusBlock, reasonBlock = '', isContractApproved) => {
  const firstSentenceMessage =  ['Sudah verifikasi OTP & atur PIN','Sudah melengkapi data identitas', 'Sudah melengkapi data usaha'];
  const secondSentenceMessage = ['belum melengkapi data identitas', 'belum melengkapi data usaha', 'belum terverifikasi AI'];

  if(statusBlock === 1){
    return(
      <AlertInfo color="red">Akun Subpangkalan telah diblokir dengan alasan <span style={{ fontWeight: 500 }}>{reasonBlock}</span></AlertInfo>
    );
  }
  else if([1, 2, 3, 5].includes(statusReg)){
    return(
      <AlertInfo title="Menunggu Verifikasi" type="warning"><span style={{ fontWeight: 500 }}>{firstSentenceMessage[statusReg-1] || 'Verifikasi AI Ditolak'}</span> {[1,2,3].includes(statusReg) && 'namun'} <span style={{ fontWeight: 500 }}>{secondSentenceMessage[statusReg-1] || ''}</span></AlertInfo>
    );
  }else if(statusReg === 4 && !isContractApproved){
    return(<AlertInfo title="Terverifikasi" type="success"><span style={{ fontWeight: 500 }}>Verifikasi AI berhasil,</span> tapi <span style={{ fontWeight: 500 }}>belum setujui kontrak</span></AlertInfo>);
  }else if(statusReg === 4 && isContractApproved){
    return(<AlertInfo title="Terverifikasi" type="success"><span style={{ fontWeight: 500 }}>Verifikasi AI berhasil</span> dan <span style={{ fontWeight: 500 }}>sudah menyetujui kontrak</span></AlertInfo>);
  }else{
    return null;
  }
};

export const renderStatusSubMerchant = (statusReg, statusBlock, isContractAgreed) => {
  let color = 'default';
  let labelStatus = 'Tidak Aktif';
  if(statusBlock === STATUS_SUB_MERCHANT_VERIF.BLOCKED){
    color = 'red';
    labelStatus = 'Diblokir';
  }else if (statusReg === STATUS_SUB_MERCHANT_VERIF.ACTIVE && isContractAgreed){
    color = 'green';
    labelStatus ='Terverifikasi';
  }else{
    color = 'orange';
    labelStatus = 'Menunggu Verifikasi';
  }
  return(
    <SolidBadge color={color}>
      {labelStatus}
    </SolidBadge>
  );
};

const FoundSubMerchant = ({ data }) => {
  const navigate = useNavigate();
  const listInfo = [
    { label: 'ID Registrasi Subpangkalan', value: data?.registrationId },
    { label: 'Tanggal Registrasi', value: data?.registrationDate ? data?.registrationDate?.split('|')[0] : '-' },
    { label: 'Jam Registrasi', value: data?.registrationTime || '-' },
  ];

  return (
    <Card withBorder>
      <Flex justify="space-between" mb="sm">
        <Flex align="center" gap="sm">
          <Paper bg="#EBF1E1" display="flex" p={8} radius={15} >
            <IconSubMerchant />
          </Paper>
          <Text fw={500} fz="lg">{data?.storeName || '-'}</Text>
        </Flex>
        {renderStatusSubMerchant(data?.registrationStatus, data?.isBlocked, data.isContractAgreed)}
      </Flex>
      {renderStatusRegistration(data?.registrationStatus, data?.isBlocked,
        data?.blockedReason, data?.isContractAgreed)}
      <Paper my="sm">
        {listInfo.map((item, idx) => (
          <Grid key={idx}>
            <Grid.Col py=".25rem" span={6}>
              <Text fw={500} fz={18}>{item.label}</Text>
            </Grid.Col>
            <Grid.Col py=".25rem" span={6}>
              <Flex gap=".25rem">
            : <Text c="#52575C">{item.value}</Text>
              </Flex>
            </Grid.Col>
          </Grid>
        ))}
      </Paper>
      <Button onClick={() =>
        navigate(`/sub-merchant/setting-data-sub-merchant/detail/${data?.registrationId}`)}>
        <Flex align="center" gap="xs">
            Lihat Rincian Data Subpangkalan
          <IconArrowRight/>
        </Flex>
      </Button>
    </Card>
  );
};

export default FoundSubMerchant;

FoundSubMerchant.propTypes = {
  data: PropTypes.object
};
